<template>
  <v-navigation-drawer width="400px" v-model="drawer" stateless overlay-opacity="0.2" fixed temporary right clipped app>
    <template v-slot:prepend>
      <v-toolbar flat color="primary" dark>
        <span class="text- subtitle-1 font-weight-bold">Filtro Contas a Receber</span>
        <v-spacer></v-spacer>
          <v-btn text icon @click="fechar">
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </template>

    <v-card flat>
      <v-card-text>
        <!-- <h1 class="text--primary subtitle-1 font-weight-bold">Filtro de Cheques</h1> -->

        <v-row dense no-gutters>
          <v-col cols="12">
            <v-autocomplete v-model="filtro.cliente_id" filled ref="responsavel" placeholder=" " label="Cliente Responsável" :items="$store.getters['listas/clientes']" clearable></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-select v-model="filtro.status" filled :items="$globals.STATUS_CHEQUE" placeholder=" " label="Situação do Cheque" clearable></v-select>
          </v-col>

          <v-col cols="12">
            <v-autocomplete v-model="filtro.banco" filled ref="banco" placeholder=" " label="Banco" :items="$store.getters['listas/bancos']" clearable></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <z-date-range-picker v-model="filtro.vencimento" filled ref="vencimento" placeholder=" " label="Data de Vencimento" clearable></z-date-range-picker>
          </v-col>

          <v-col cols="12">
            <z-date-range-picker v-model="filtro.cadastro" filled ref="cadastro" placeholder=" " label="Data de Cadastro" clearable></z-date-range-picker>
          </v-col>
        </v-row>
        
      </v-card-text>
    </v-card>

    <template v-slot:append>
      <v-divider></v-divider>
      <v-card flat>
        <v-card-actions>
          <v-btn text @click="redefinir">Limpar Filtro</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="fechar">Fechar</v-btn>
          <v-btn depressed color="primary" @click="aplicar" :loading="aplicando">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-navigation-drawer>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        drawer: false,
        filtro: {
          cliente_id: null,
          status: null,
          banco: null,
          vencimento: [],
          cadastro: []
        },
        aplicando: false,
      }
    },

    mounted() {
      window.addEventListener('keydown', this.teclaESC);
    },

    beforeDestroy() {
      window.removeEventListener('keydown', this.teclaESC);
    },

    methods: {

      teclaESC(e) {
        if (e.key === 'Escape') {
          this.fechar();
        }
      },

      abrir() {
        this.filtro = this.clone(this.$store.state.cheques.filtro);
        this.drawer = true;
      },

      fechar() {
        this.drawer = false;
      },

      async aplicar() {
        try {
          this.aplicando = true;
          await this.$store.dispatch('cheques/filtrarCheques', this.filtro);
          this.fechar();
        } catch (error) {
          this.$eventbus.erroSistema(error);
          // this.$eventbus.erroSistema('Não foi possível aplicar o filtro.');
        } finally {
          this.aplicando = false;
        }
      },

      redefinir() {
        this.filtro = {
          cliente_id: null,
          status: null,
          banco: null,
          vencimento: [],
          cadastro: []
        }

        this.aplicar(true);
      },

      validar() {
        if ( this.filtro.cliente_id == null && this.filtro.status == null && this.filtro.banco == null && this.filtro.vencimento.length == 0 && this.filtro.cadastro.length == 0)
            return false;

          return true;
      },

    },

  }
</script>

<style scoped>

</style>